import PropTypes from 'prop-types'

import styled from 'styled-components'

const StyledMegaMenuSubMenuContent = styled.div`
  display: ${props => props.visible ? 'block' : 'none'};
`

const MegaMenuSubMenu = ({ children, visible }) => {
  return (
    <StyledMegaMenuSubMenuContent visible={visible} data-test='megamenu-submenu-content'>
      {children}
    </StyledMegaMenuSubMenuContent>
  )
}

MegaMenuSubMenu.propTypes = {
  children: PropTypes.node.isRequired,
  visible: PropTypes.bool,
}

export default MegaMenuSubMenu
